export default {
  sm: `
  V-shape structure for 
  wind path
  `
};
